/* eslint-disable */
export default function listSearch() {
    const listSearchForm = document.querySelector('.js-list-search-form');

    if (!listSearchForm) {
        return;
    }

    function startSearch(event) {
        event.preventDefault();
        listSearchForm.classList.add('open');
        listSearchForm.querySelector('input').focus();
    }

    function endSearch() {
        listSearchForm.classList.remove('open');
    }

    const searchButton = document.querySelector('.js-list-search-search-button');
    if (searchButton) {
        searchButton.addEventListener('click', (event) => startSearch(event));
    }

    const closeButton = listSearchForm.querySelector('.js-list-search-close');
    if (closeButton) {
        closeButton.addEventListener('click', endSearch);
    }
}

window.addEventListener('load', listSearch);

